import {Classe} from "@/router/Grille/Classe.js";
import {Category} from "@/router/Grille/Category.js";

export const Grille = {
    path: '/grille',
    name: 'grille',
    component: () => import('@/views/Grille/GrillePage.vue'),
    children: [
        Category,
        Classe,
    ],
}